import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type IntlService from 'ember-intl/services/intl';
import type GroupInviteLink from 'invite-sign/models/group-invite-link';
import type { GroupInviteLinkRouteModel } from 'invite-sign/routes/group-invite';
import type { Step } from 'invite-sign/services/invite-steps';

export interface GroupInviteLinkShowRouteModel extends GroupInviteLinkRouteModel {
  steps: Step[];
}

export default class GroupInviteLinkShowRoute extends Route {
  @service declare intl: IntlService;
  @service declare store: Store;

  model(): GroupInviteLinkShowRouteModel {
    const { groupInviteLink, location } = <GroupInviteLinkShowRouteModel>this.modelFor('group-invite');
    const steps = groupInviteLink ? this.buildSteps(groupInviteLink) : [];

    return {
      groupInviteLink,
      location,
      steps,
    };
  }

  buildSteps(_invite: GroupInviteLink): Step[] {
    const intl = this.intl;
    const steps: Step[] = [{ route: 'group-invite.show.fill', label: intl.t('steps.add_details') }];

    return steps;
  }
}
